var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    transform: "rotate(90 10 10)",
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 5.58866 14.4113 2 10 2C5.58866 2 2 5.58866 2 10C2 14.4113 5.58866 18 10 18C14.4113 18 18 14.4113 18 10ZM9.52866 12.4713L6.19534 9.138C6.06534 9.008 6 8.83734 6 8.66666C6 8.496 6.06534 8.32531 6.19534 8.19531C6.456 7.93466 6.87734 7.93466 7.138 8.19531L10 11.0573L12.862 8.19534C13.1227 7.93469 13.544 7.93469 13.8047 8.19534C14.0653 8.456 14.0653 8.87734 13.8047 9.138L10.4713 12.4713C10.2107 12.732 9.78934 12.732 9.52866 12.4713Z",
    fill: "#65676A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandHover);
export default __webpack_public_path__ + "static/media/expandHover.11d9df4a0a1e2199b8365591b04f01a3.svg";
export { ForwardRef as ReactComponent };